export const RD_PROJECT_BULK_UPLOAD_ONESCHEMA_TEMPLATE_KEY = 'rd-project-upload';
